'use strict';

export default class ArticleLink {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    
    if(selfInit) this.init();
  }

  init() {
    this.$selector.each((index, item) => {
      const $item = $(item)
      const findHref = $item.find('[href]').length > 0;

      if (findHref) {
        $item.addClass("has-link");
      }
    });
  }
}
